import './ReferralList.scss'
import _ from 'lodash'
import ReferralAgentSuccessHeader from 'manager/common/AgentSuccess'
import React, { Component } from 'react'
import { push } from 'react-router-redux'
import { createFilter } from 'react-search-input'
import cx from 'bem-classnames'
import { Button, Modal } from 'react-bootstrap'
import { show as showModal, connectModal } from 'redux-modal'
import { AGENT_STATUS, AGENT_SUCCESS_TOUCH_STAGES, BROKER_DELINQUENT_MESSAGE, BROKER_DELINQUENT_MESSAGE_BLA } from 'common/constants'
import {
  fetchAccount,
  fetchNotifyActive,
  restoreReleased,
  fetchStats,
  updateReferralSearch
} from 'manager/redux/referral_list'
import {
  setBanner, setAgreementBanner
} from 'common/redux/root'
import { labelFor} from 'common/util/helper'
import { isEmbedded, isEmbeddedOrMobileBrowser } from 'common/util/features'
import { ReferralItem, ReleasedReferralItem, ConfirmedClosedReferralItem } from 'manager/views/components/Referral/ReferralItem'
import { OpSearchInput } from 'common/views/atoms/OpSearchInput'
import { isHeaderHidden } from 'common/util/features'
import { parse, isWithinRange, addDays, isAfter } from 'date-fns'

const TABS_WITH_SEARCH = ['active', 'holding', 'released', 'closed']

const isWithinDaysOfToday = (date, start, end) => date && isWithinRange(new Date(), addDays(date, start), addDays(date, end))
const isTodayAfterDaysOf = (date, days) => isAfter(new Date(), addDays(date, days))

const isToday1to7DaysFrom = dateStr => dateStr && isWithinDaysOfToday(parse(dateStr), 1, 7)
const isToday7PlusDaysFrom = dateStr => dateStr && isTodayAfterDaysOf(parse(dateStr), 7)


const ReferralSection = ({ title, children }) => {
  return (
    <div className="ReferralList__section">
      <div className="ReferralList__section__header">{ title }</div>
      <div className="ReferralList__section__content">
        { children }
      </div>
    </div>)
}

const NoHoldingReferralSection = () => {
  return <div className="ReferralList__none-found">
    <i className="fa fa-flag" aria-hidden="true"></i><div>You have no referrals marked as long-term hold.</div>
  </div>
}

const NoReleasedReferralSection = () => {
  return <div className="ReferralList__none-found">
    <i className="fa fa-flag" aria-hidden="true"></i><div>You have no released referrals available to restore.</div>
  </div>
}

const NoClosedSection = () => {
  return <div className="ReferralList__none-found">
    <i className="fa fa-flag" aria-hidden="true"></i><div>You have no closed referrals yet.</div>
  </div>
}

export const NoReferralSection = ({ agentSignedUpAt, hasAlerts, numAssigned }) => {
  const shouldShowAcquainted = numAssigned === 0 && isToday1to7DaysFrom(agentSignedUpAt)
  const shouldShowStillNotAssigned = numAssigned === 0 && hasAlerts && isToday7PlusDaysFrom(agentSignedUpAt)

  if (!_.some([shouldShowAcquainted, shouldShowStillNotAssigned])) {
    return (
      <div className="ReferralList__none-found">
        <i className="fa fa-flag" aria-hidden="true"></i><div>You have no active referrals assigned to you.</div>
      </div>
    )
  }

  return <ReferralAgentSuccessHeader stage={shouldShowAcquainted ? AGENT_SUCCESS_TOUCH_STAGES.FIRST_WEEK : AGENT_SUCCESS_TOUCH_STAGES.AFTER_FIRST_WEEK}/>
}

const doFetchStats = _.debounce(dispatch => dispatch(fetchStats()), 10000, {
  leading: true,
  trailing: false,
  maxWait: 10000
})

class ConfirmRestore extends Component {

  noteRef = null

  state = {
    restore_note: '',
  }

  componentDidMount(){
    setTimeout(() => this.noteRef.focus())
  }

  handleChange = (e) => {
    this.setState({restore_note: e.target.value})
  }

  handleClick = () => {
    this.props.dispatch(restoreReleased(this.props.initialState.hash, {restored: this.props.restored, restore_note: this.state.restore_note}))
    this.props.handleHide()
  }

  render() {
    return (
      <Modal className="ReferralList__release-modal" show={this.props.show}>
          <Modal.Header>
              <Modal.Title>Restore Referral - {this.props.initialState.name}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="text">Nice work restoring this referral! Please enter a short status update below to set this referral to active.</div>
            <div className="ReferralStatusUpdate__label">Note <span className="ReferralStatusUpdate__required">REQUIRED</span></div>
            <textarea ref={elem => this.noteRef = elem} value={this.state.restore_note} className="ReferralStatusUpdate__note" onChange={this.handleChange} />
          </Modal.Body>

          <Modal.Footer>
              <button className="pull-left btn btn-success" disabled={!this.state.restore_note} onClick={this.handleClick}>Restore</button>
              <Button onClick={this.props.handleHide}>Cancel</Button>
          </Modal.Footer>
      </Modal>
    )
  }
}
const ConfirmRestoreModal = connectModal({ name: 'ConfirmRestoreModal', destroyOnHide: true })(ConfirmRestore)

class StatsSection extends Component {

  componentWillMount() {
      doFetchStats(this.props.dispatch)
  }

  render() {
    const { dispatch, referralList, user } = this.props
    const { stats } = referralList
    const isEmerging = user.agent_experience_level === 'emerging'
    const isExperienced = user.agent_experience_level === 'experienced'
    const isTransitionedExperienced = user.is_transitioned_experienced
    const progressWidth = stats && stats.agent_status.closed_count * 100.00
    const progressComplete = stats && stats.agent_status.closed_count >= 1
    const showLeaderboard = !isEmbedded()

    function getTargetClassname(target, actual) {
      return actual < (target * .7) ? '-danger' : ''
    }

    function getTargetTimeClassname(target, actual) {
      return actual > (target / .7) ? '-danger' : ''
    }

    function getWidthPercentage(score) {
      return score !== null ? ((Math.round(score * 2) / 10) * 100) + '%' : '100%'
    }

    if (!stats) {
      return <div>Loading...</div>
    }

    return <div className="StatsSectionWrapper"><div className="StatsSection">
      <h3>My Network Participation</h3>
      <div className="StatsSection__box">
        <div className="StatsNetwork__row">
          <div className="StatsNetwork__row-left">
            <div className="StatsNetwork__row-left-header">
              Referral Manager Up-To-Date
            </div>
            <div className="StatsNetwork__row-left-sub">
              How well you keep Opcity up to date on status
            </div>
          </div>
          <div className="StatsNetwork__row-right">
            <div className="StatsNetwork__stars StatsNetwork__stars-open">
              <div>★</div><div>★</div><div>★</div><div>★</div><div>★</div>
            </div>
            <div className="StatsNetwork__stars StatsNetwork__stars-filled" style={ {width: getWidthPercentage(stats.agent_status.opcity_score)} }>
              <div>★</div><div>★</div><div>★</div><div>★</div><div>★</div>
            </div>
          </div>
        </div>
        <hr/>
        <div className="StatsNetwork__row">
          <div className="StatsNetwork__row-left">
            <div className="StatsNetwork__row-left-header">
              Client Satisfaction
            </div>
            <div className="StatsNetwork__row-left-sub">
              How clients rate their experience with you
            </div>
          </div>
          <div className="StatsNetwork__row-right">
            <div className="StatsNetwork__stars StatsNetwork__stars-open">
              <div>★</div><div>★</div><div>★</div><div>★</div><div>★</div>
            </div>
            <div className="StatsNetwork__stars StatsNetwork__stars-filled" style={ {width: getWidthPercentage(stats.agent_status.client_avg_score)} }>
              <div>★</div><div>★</div><div>★</div><div>★</div><div>★</div>
            </div>
          </div>
        </div>
      </div>
      <h3>My Achievements</h3>
      { stats.agent_status.badge_agent_training ? null : <div className="StatsSection__help" onClick={() => dispatch(showModal("HelpModal"))}>Learn More</div> }
      <div className="StatsSection__box StatsBadges">
        <div className="StatsBadges__row">
          <div className={"StatsBadges__cell " + (stats.agent_status.badge_agent_training ? "" : "StatsBadges__cell-unchecked")}>
            <div className="StatsBadges__badge StatsBadges__img-training">
              {stats.agent_status.badge_agent_training ? <div className="StatsBadges__img-check"/> : null }
            </div>
            <div className="StatsBadges__text">Attended Agent Webinar</div>
          </div>
          <div className={"StatsBadges__cell " + (stats.agent_status.badge_first_referral ? "" : "StatsBadges__cell-unchecked")}>
            <div className="StatsBadges__badge StatsBadges__img-referral">
              {stats.agent_status.badge_first_referral ? <div className="StatsBadges__img-check"/> : null }
            </div>
            <div className="StatsBadges__text">Accepted First Referral</div>
          </div>
          <div className={"StatsBadges__cell " + (stats.agent_status.badge_first_close ? "" : "StatsBadges__cell-unchecked")}>
            <div className="StatsBadges__badge StatsBadges__img-close">
              {stats.agent_status.badge_first_close ? <div className="StatsBadges__img-check"/> : null }
            </div>
            <div className="StatsBadges__text">Closed First Client</div>
          </div>
        </div>
      </div>
      <h3>My Closes</h3>
      <div className="StatsSection__box StatsCloses">
        <div className="StatsCloses__row">
          <div className="StatsCloses__left">
            <div className={"StatsCloses__left-number " + (stats.agent_status.closed_count === 0 ? "-danger" : "-success")}>{stats.agent_status.closed_count}</div>
            <div className="StatsCloses__left-text">Total All-Time<br/> Closes</div>
          </div>
          <div className="StatsCloses__right">
            <div className="StatsCloses__right-row">
              <div className="StatsCloses__right-number">{stats.agent_status.opcity_lender_count}</div>
              <div className="StatsCloses__right-text">Opcity Loan<br/> Partners Used</div>
            </div>
            <div className="StatsCloses__right-row">
              <div className="StatsCloses__right-number">{stats.agent_status.opcity_settlement_count}</div>
              <div className="StatsCloses__right-text">Opcity Title<br/> Partners Used</div>
            </div>
          </div>
        </div>
      </div>
      { isEmerging || isExperienced ? <div className="StatsSection__emerging-progress">
        <div className="StatsSection__emerging-progress-bar">
          { progressComplete ? <div className="StatsSection__emerging-progress-bar-filled" /> : <div style={{width: `${progressWidth}%`}} /> }
          { progressComplete ? <div className="StatsSection__emerging-progress-unlock" /> : <div className="StatsSection__emerging-progress-lock" /> }
        </div>
        <div className="StatsSection__emerging-progress-labels">
          <div>0</div>
          <div>1</div>
          <div>2</div>
          <div>3</div>
        </div>
        { isEmerging ? <p>
          As an <strong>emerging agent</strong>, you must <strong>close
          3 clients</strong> before you can disable zip codes and set price categories.
        </p> : null }
        { isTransitionedExperienced ? <p>
          Congratulations! As an <strong>experienced agent</strong> with{" "}
          <strong>3 closed clients</strong>, you can now disable zip codes
          and set price categories.
        </p> : null }
      </div> : null }
      <h3>My Personal Stats</h3>
      <div className="StatsSection__box">
        <table>
          <thead>
            <tr>
              <th style={{width:"50%"}}>Agents who…</th>
              <th style={{width:"24%"}}>Me</th>
              <th style={{width:"26%"}}>Top 10% Agents</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Met Clients</td>
              <td className={getTargetClassname(stats.agent_status.met_target_percent, stats.agent_status.met_percent)}>{ stats.agent_status.met_percent }%</td>
              <td>{ stats.agent_status.met_target_percent }%</td>
            </tr>
            <tr className="-row-space-top">
              <td>Closed</td>
              <td className={getTargetClassname(stats.agent_status.closed_target_percent, stats.agent_status.closed_percent)}>{ stats.agent_status.closed_percent }%</td>
              <td>{ stats.agent_status.closed_target_percent }%</td>
            </tr>
            <tr className="-row-space-bottom">
              <td>Avg Click Time</td>
              <td className={getTargetTimeClassname(stats.agent_status.avg_target_click_time_seconds, stats.agent_status.avg_click_time_seconds)}>{ stats.agent_status.avg_click_time }</td>
              <td>{ stats.agent_status.avg_target_click_time }</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div></div>
  }
}

class ReferralList extends Component {

  state = {
    activeTab: 'active',
    canSearchStatus: true,
  }

  componentDidMount() {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage && isHeaderHidden()) {
      setTimeout(() => window.ReactNativeWebView.postMessage('referral-list'))
    }

    return Promise.all([
      this.props.dispatch(fetchAccount(true)),
      this.props.dispatch(fetchNotifyActive())
    ])
  }

  componentDidUpdate() {
    // Leaving this here as an example of how to use the generic referral manager banner feature
    /*if(this.props.referralList.account && !this.props.referralList.account.mobile_enabled) {
      const bannerContent = <div>Opcity now has a mobile app! Click <a href="https://mobile.opcity.com" target="_blank">here to download</a></div>
      this.props.dispatch(setInfoBanner(bannerContent))
    }*/
    const { dispatch, referralList } = this.props
    const { account } = referralList

    const brokerIsDelinquent = account && account.broker_status && account.broker_status === 'delinquent'

    const brokerIsBLA = account && account.broker_is_bla

    dispatch(setAgreementBanner(false)) // disabled
    if (brokerIsDelinquent && !isEmbeddedOrMobileBrowser()) {
      const bannerMessage = brokerIsBLA ? BROKER_DELINQUENT_MESSAGE_BLA : BROKER_DELINQUENT_MESSAGE
      dispatch(setBanner(bannerMessage))
    } else {
      dispatch(setBanner(false))
    }
  }

  changeTab = newTab => {
    if(this.state.activeTab != newTab && this._list_div) {
      this._list_div.scrollTop = 0
    }

    this.setState({
      activeTab: newTab,
      canSearchStatus: ['active', 'holding'].includes(newTab)
    })

    if (newTab === 'released') {
      this.props.dispatch(fetchAccount(false, true))
    }

  }

  openItem = item => {
    const { dispatch } = this.props
    dispatch(push({pathname: '/referral/' + item.hash, query: location.query}))
  }

  openRestoreModal = item => {
    const { dispatch, referralList: { restored }} = this.props
    dispatch(showModal("ConfirmRestoreModal", {initialState: item, restored: restored, dispatch: dispatch}))
  }

  addTransaction = item => {
    const { dispatch } = this.props
    dispatch(push({
      pathname:`/referral/${item.hash}`,
      query: { ...location.query, 'add': true },
    }))
  }

  updateSearchText = searchText => {
    this.props.dispatch(updateReferralSearch(searchText))
  }

  getFilteredItems = (items = []) => {
    const { referralList: { search = '' }} = this.props
    const { canSearchStatus } = this.state

    const keys = canSearchStatus ? ['name', 'phone', 'email', 'agent_status'] : ['name', 'phone', 'email']

    return search ? items.filter(createFilter(search, keys)) : items
  }

  render() {

    const {
      referralList: {
        need_urgent_action = [],
        need_action = [],
        active = [],
        holding = [],
        closed = [],
        confirmed_closed = [],
        released = [],
        account,
        restored,
        restoring,
        search,
        historical_assigned_count,
        has_referrals,
        has_received_alerts,
      },
    } = this.props

    const { canSearchStatus, activeTab } = this.state

    const searchPlaceholder = canSearchStatus ? "Name, Status, Email, Phone" : "Name, Email, Phone"

    if (!this.props.referralList.need_action || !this.props.referralList.active) {
      return <div></div>
    }

    const statusClasses = {
      name: 'AccountHeader__status',
      modifiers: ['active', 'warning', 'disabled', 'delinquent']
    }

    const unreleasedAssignmentHashes = _.union(
        _.flatten([
            this.props.referralList.need_urgent_action,
            this.props.referralList.need_action,
            this.props.referralList.active,
            this.props.referralList.holding
        ]).map((transaction) => transaction.assignment_hash)
    )

    const isAssignmentUnreleased = (item) => !unreleasedAssignmentHashes.includes(item.assignment_hash)

    const activeAlertCount = (
      this.props.referralList.need_urgent_action ? this.props.referralList.need_urgent_action.length : 0
      ) + (
        this.props.referralList.need_action ? this.props.referralList.need_action.length : 0
      )

    return (
      <div className="ReferralList">
        <div className="AccountHeader">
          <div className="AccountHeader__left">
            <div className="AccountHeader__name">{ account.name }</div>
            <div className={cx(statusClasses, {[account.status]: true})}>
              <i className="fa fa-circle" aria-hidden="true"></i>
              <span>{labelFor(AGENT_STATUS, account.status)}</span>
            </div>
          </div>
          <div className="AccountHeader__right">
            <div className="AccountHeader__value">{ account.closed_count }</div>
            <div className="AccountHeader__title">Closes</div>
          </div>
          <div className="AccountHeader__right">
            <div className="AccountHeader__value">{ account.met_count }</div>
            <div className="AccountHeader__title">Met</div>
          </div>
          <div className="AccountHeader__right">
            <div className="AccountHeader__value">{ account.assigned_count }</div>
            <div className="AccountHeader__title">Referrals</div>
          </div>
        </div>
        <div className="AccountTabs">
          <div className={"AccountTabs__tab clickable " + (activeTab === 'active' ? 'AccountTabs__tab--active' : '') } onClick={() => this.changeTab('active')}>
            <div className="AccountTabs__name">Active {activeAlertCount ? <span className="AccountTabs__count">{ activeAlertCount }</span> : null}</div>
          </div>
          <div className={"AccountTabs__tab clickable " + (activeTab === 'holding' ? 'AccountTabs__tab--active' : '') } onClick={() => this.changeTab('holding')}>
            <div className="AccountTabs__name">Holding</div>
          </div>
          <div className={"AccountTabs__tab clickable " + (activeTab === 'released' ? 'AccountTabs__tab--active' : '') } onClick={() => this.changeTab('released')}>
            <div className="AccountTabs__name">Released</div>
          </div>
          <div className={"AccountTabs__tab clickable " + (activeTab === 'closed' ? 'AccountTabs__tab--active' : '') } onClick={() => this.changeTab('closed')}>
            <div className="AccountTabs__name">Closed</div>
          </div>
          <div className={"AccountTabs__tab clickable " + (activeTab === 'stats' ? 'AccountTabs__tab--active' : '') } onClick={() => this.changeTab('stats')}>
            <div className="AccountTabs__name">Stats <i className="fa fa-star" /></div>
          </div>
        </div>
        {TABS_WITH_SEARCH.includes(activeTab) && (
          <div className="SearchBar">
            <OpSearchInput
              onChange={this.updateSearchText}
              placeholder={searchPlaceholder}
              value={search} />
          </div>
        )}
        <div className="ReferralList__scrollwindow">
          <div className="ReferralList__list" ref={(ref) => this._list_div = ref} >
            { (need_urgent_action.length + need_action.length) > 0 && activeTab == 'active' && (
              <ReferralSection title="Needs Action">
                { this.getFilteredItems([...need_urgent_action, ...need_action]).map(item => (
                  <ReferralItem key={item.hash} item={item} onClick={this.openItem} search={search} />)
                )}
              </ReferralSection>
            )}
            { active.length > 0 && activeTab == 'active' && (
              <ReferralSection title="Active">
                { this.getFilteredItems(active).map(item => (
                  <ReferralItem key={item.hash} item={item} onClick={this.openItem} search={search} />)
                )}
              </ReferralSection>
            )}
            { closed.length > 0 && activeTab == 'active' && (
              <ReferralSection title="Closed - Pending Broker Confirmation">
                { this.getFilteredItems(closed).map(item => (
                  <ReferralItem key={item.hash} item={item} onClick={this.openItem} search={search} />)
                )}
              </ReferralSection>
            )}
            { holding.length > 0 && activeTab == 'holding' && (
              <ReferralSection title="Long-Term Hold">
                { this.getFilteredItems(holding).map(item => (
                  <ReferralItem key={item.hash} item={item} onClick={this.openItem} search={search} />)
                )}
              </ReferralSection>
            )}
            { released.length > 0 && activeTab == 'released' && (
              <ReferralSection title="Released">
                { this.getFilteredItems(_.uniqBy(released, 'assignment_hash').filter(isAssignmentUnreleased)).map(item => (
                  <ReleasedReferralItem
                    key={item.hash}
                    item={item}
                    onClick={this.openRestoreModal}
                    search={search}
                    isRestored={restored.includes(item.hash)}
                    restoring={restoring}  />
                ))}
              </ReferralSection>
            )}
            { confirmed_closed.length > 0 && activeTab == 'closed' && (
              <ReferralSection title="Closed">
                { this.getFilteredItems(confirmed_closed).map(item => (
                  <ConfirmedClosedReferralItem
                    key={item.hash}
                    item={item}
                    onClick={this.addTransaction}
                    search={search} />
                ))}
              </ReferralSection>
            )}
            { !has_referrals && activeTab == 'active' && (
              <NoReferralSection
                agentSignedUpAt={account.agent_agreement_signed_at}
                numAssigned={historical_assigned_count}
                hasAlerts={has_received_alerts}
              />
            )}
            { holding.length == 0 && activeTab == 'holding' && <NoHoldingReferralSection /> }
            { released.length == 0 && activeTab == 'released' && <NoReleasedReferralSection /> }
            { confirmed_closed.length == 0 && activeTab == 'closed' && <NoClosedSection {...this.props} /> }

            { activeTab == 'stats' && <StatsSection {...this.props} /> }
          </div>
        </div>
        <ConfirmRestoreModal />
      </div>)
  }
}

export default ReferralList
